import type { ProductGroup } from '../types/productGroup';

/** 商品组类型 code 与展示名称（与编辑页选项一致） */
export const PRODUCT_GROUP_CATEGORY_MAP: Record<string, string> = {
  bike: '电动车',
  scooter: '电动滑板',
  accessory: '配件',
};

const lookupMap = (map: Record<string, string>, value?: string | null): string | undefined => {
  if (!value?.trim()) {
    return undefined;
  }
  const trimmed = value.trim();
  return map[trimmed] ?? map[trimmed.toLowerCase()];
};

const looksLikeEnumCode = (value: string) => /^[a-z][a-z0-9_]*$/i.test(value);

export const pickProductGroupCategoryFields = (
  record: Pick<ProductGroup, 'category' | 'categoryDesc'> & {
    category_desc?: string;
  }
): { code?: string; desc?: string } => ({
  code: record.category,
  desc: record.categoryDesc ?? record.category_desc,
});

/**
 * 解析商品组类型展示名
 */
export const getProductGroupCategoryLabel = (
  code?: string | null,
  desc?: string | null
): string => {
  const normalizedCode = code?.trim() || '';
  const normalizedDesc = desc?.trim() || '';

  const fromCode = lookupMap(PRODUCT_GROUP_CATEGORY_MAP, normalizedCode);
  if (fromCode) {
    return fromCode;
  }

  const fromDesc = lookupMap(PRODUCT_GROUP_CATEGORY_MAP, normalizedDesc);
  if (fromDesc) {
    return fromDesc;
  }

  if (normalizedDesc && normalizedDesc !== normalizedCode && !looksLikeEnumCode(normalizedDesc)) {
    return normalizedDesc;
  }

  return normalizedCode || '--';
};
